import { observer } from 'mobx-react';
import * as React from 'react';
import { Loader } from '..';

export interface IStatusCardProps {
    readonly className?: string;
    readonly title: string | React.ReactNode | JSX.Element;
    readonly infoLink?: React.ReactNode;
    readonly offline?: boolean;
    readonly bodyClassName?: string;
    readonly loading?: boolean;
    readonly iconContainer?: string;
}

@observer
export class StatusCard extends React.Component<IStatusCardProps> {
    public render() {
        return (
            <div className={'h-100 ' + this.props.className}>
                <div className="row h-100">
                    <div className="col-12">
                        <ul className="status-list list-group h-100 p-2">
                            <div className="status-list-title">{this.props.title}</div>
                            {!this.props.loading && this.props.children}
                            <Loader message="Loading..." center loading={this.props.loading ?? false} />
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}
